import { invitationsServiceModule } from '../../../../shared/app/services/invitations-service/invitations-service';
import { accountServiceModule } from '../../../../shared/app/services/account-service/account-service';
import { checkEmailServiceModule } from '../../../../shared/app/services/check-email-service/check-email-service';
import registerAccountTemplate from './register-account.tpl.html';
import './register-account.less';

export const registerAccountComponentModule = angular
  .module('Q.components.register-account', [
    invitationsServiceModule,
    accountServiceModule,
    checkEmailServiceModule,
  ])

  .component('registerAccount', {
    bindings: {
      auth: '<',
      onRegistered: '&',
    },
    template: registerAccountTemplate,
    controller: 'RegisterAccountCtrl',
  })
  .controller(
    'RegisterAccountCtrl',
    function RegisterAccountCtrl(
      $scope,
      $element,
      $injector,
      $stateParams,
      $q,
      invitationsService,
      accountService,
      checkEmailService,
      $timeout,
    ) {
      const ctrl = this;

      ctrl.$onInit = () => {
        // assign default state variables
        ctrl.email = ctrl.auth.email
          ? ctrl.auth.email
          : ctrl.user
            ? ctrl.user.email
            : $stateParams.email;
        ctrl.firstName = $stateParams.firstName;
        ctrl.lastName = $stateParams.lastName;
        _assignState();
        _checkEmail();

        $timeout(() => {
          if ($stateParams.autoRegister) {
            ctrl.submit();
          }
        });
      };

      if ($injector.has('productMaintenanceService')) {
        ctrl.maintenanceWarning = $injector
          .get('productMaintenanceService')
          .warning();
      }

      ctrl.submit = () => {
        if (ctrl.emailCheckNeeded) {
          $scope.registerForm.$setPristine();
          $scope.registerForm.$setUntouched();
          _checkEmail().then(() => {
            if (ctrl.registrationRequired && !ctrl.nameRequested) {
              _register();
            }
          });
        } else {
          _register();
        }
      };

      ctrl.submitForm = (registerForm) => {
        // Hack for LastPass and other poor password managers to try and validate changed inputs before submitting.
        let inputs = angular.element($element.find('input'));
        inputs.triggerHandler('input');
        if (registerForm.$valid) {
          ctrl.submit();
        }
      };

      ctrl.clearEmailCheck = () => {
        ctrl.emailCheck = null;
        _assignState();
      };

      ctrl.requestNewEmail = () => {
        invitationsService.resend({
          id: ctrl.auth.invitationId,
        });
        ctrl.invitationResent = true;
      };

      // recalc dynamic state variables. Done this way instead of using helper methods to make the logic
      // easier to follow.
      function _assignState() {
        ctrl.error = null;
        ctrl.user = ctrl.auth.candidate;
        ctrl.emailCheckNeeded = !ctrl.emailCheck && !ctrl.auth.user;
        ctrl.registrationRequired =
          ctrl.auth.registrationRequired && !ctrl.emailCheckNeeded;

        if (ctrl.auth.invitation) {
          ctrl.nameRequested =
            !ctrl.auth.invitation.skippedRegistration &&
            (!ctrl.auth.candidate.firstName || !ctrl.auth.candidate.lastName);
        } else {
          ctrl.nameRequested =
            ctrl.emailCheck &&
            (ctrl.emailCheck.nameNeeded || !ctrl.emailCheck.exists);
        }
      }

      function _checkEmail() {
        if (ctrl.email) {
          return checkEmailService.check(ctrl.email).then((result) => {
            ctrl.emailCheck = result;
            _assignState();
          });
        } else {
          return $q.when();
        }
      }

      function _register() {
        ctrl.disabled = true;
        ctrl.error = null;
        invitationsService
          .register({
            email: ctrl.email,
            firstName: ctrl.firstName,
            lastName: ctrl.lastName,
            assessmentId: ctrl.auth.assessment.id,
            accessToken: $stateParams.invite,
          })
          .then((auth) => {
            ctrl.registered = true;

            // update the existing auth with the one just returned
            Object.assign(ctrl.auth, auth);

            if (auth.emailVerificationRequired) {
              ctrl.registrationRequired = false;
            } else {
              accountService.setLoginAccount(auth.candidate, {
                showLoadingPanel: false,
              });
              ctrl.onRegistered({ auth: auth });
            }
          })
          .catch((error) => {
            ctrl.disabled = false;
            ctrl.error = error;
          });
      }
    },
  );
